import { match as age_group } from "../../../src/params/age_group.js";
import { match as purchase_intent } from "../../../src/params/purchase_intent.js";

export const matchers = { age_group, purchase_intent };